import _slicedToArray from "/var/www/vhosts/thuisinaanbouw.nl/gatsby/thuisinaanbouw.nl/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/var/www/vhosts/thuisinaanbouw.nl/gatsby/thuisinaanbouw.nl/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from "react";
import { ACTION_NEXT, ACTIVE_SLIDE_COMPLETE, ACTIVE_SLIDE_ERROR, ACTIVE_SLIDE_LOADING, ACTIVE_SLIDE_PLAYING, cleanup, createIcon, IconButton, label, SLIDE_STATUS_COMPLETE, SLIDE_STATUS_ERROR, SLIDE_STATUS_LOADING, SLIDE_STATUS_PLAYING, useController, useEventCallback, useEvents, useLightboxState, useTimeouts } from "../../core/index.js";
import { defaultSlideshowProps } from "./Slideshow.js";
var PlayIcon = createIcon("Play", React.createElement("path", {
  d: "M8 5v14l11-7z"
}));
var PauseIcon = createIcon("Pause", React.createElement("path", {
  d: "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
}));
export var SlideshowButton = function SlideshowButton() {
  var _useLightboxState = useLightboxState(),
      currentIndex = _useLightboxState.state.currentIndex;

  var _useController = useController(),
      getLightboxProps = _useController.getLightboxProps;

  var _useTimeouts = useTimeouts(),
      setTimeout = _useTimeouts.setTimeout,
      clearTimeout = _useTimeouts.clearTimeout;

  var _useEvents = useEvents(),
      publish = _useEvents.publish,
      subscribe = _useEvents.subscribe;

  var _getLightboxProps = getLightboxProps(),
      slideshowProps = _getLightboxProps.slideshow,
      finite = _getLightboxProps.carousel.finite,
      slides = _getLightboxProps.slides,
      render = _getLightboxProps.render,
      labels = _getLightboxProps.labels;

  var slidesCount = slides.length;

  var slideshow = _objectSpread(_objectSpread({}, defaultSlideshowProps), slideshowProps);

  var _React$useState = React.useState(slideshow.autoplay),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      playing = _React$useState2[0],
      setPlaying = _React$useState2[1];

  var scheduler = React.useRef();
  var slideStatus = React.useRef();
  var cancelScheduler = React.useCallback(function () {
    clearTimeout(scheduler.current);
    scheduler.current = undefined;
  }, [clearTimeout]);
  var reachedLastSlide = useEventCallback(function () {
    return slides.length === 0 || finite && currentIndex === slidesCount - 1;
  });
  var scheduleNextSlide = useEventCallback(function () {
    cancelScheduler();

    if (!playing || reachedLastSlide() || slideStatus.current === SLIDE_STATUS_LOADING || slideStatus.current === SLIDE_STATUS_PLAYING) {
      return;
    }

    scheduler.current = setTimeout(function () {
      if (playing) {
        slideStatus.current = undefined;
        publish(ACTION_NEXT);
      }
    }, slideshow.delay);
  });
  var togglePlaying = React.useCallback(function () {
    setPlaying(function (prev) {
      return !prev;
    });
  }, []);
  React.useEffect(scheduleNextSlide, [currentIndex, playing, scheduleNextSlide]);
  React.useEffect(function () {
    if (playing && reachedLastSlide()) {
      setPlaying(false);
    }
  }, [currentIndex, playing, reachedLastSlide]);
  React.useEffect(function () {
    return cleanup(subscribe(ACTIVE_SLIDE_LOADING, function () {
      slideStatus.current = SLIDE_STATUS_LOADING;
      cancelScheduler();
    }), subscribe(ACTIVE_SLIDE_PLAYING, function () {
      slideStatus.current = SLIDE_STATUS_PLAYING;
      cancelScheduler();
    }), subscribe(ACTIVE_SLIDE_ERROR, function () {
      slideStatus.current = SLIDE_STATUS_ERROR;
      scheduleNextSlide();
    }), subscribe(ACTIVE_SLIDE_COMPLETE, function () {
      slideStatus.current = SLIDE_STATUS_COMPLETE;
      scheduleNextSlide();
    }), cancelScheduler);
  }, [subscribe, cancelScheduler, scheduleNextSlide]);
  var disabled = reachedLastSlide();
  return render.buttonSlideshow ? React.createElement(React.Fragment, null, render.buttonSlideshow({
    playing: playing,
    togglePlaying: togglePlaying,
    disabled: disabled
  })) : React.createElement(IconButton, {
    label: playing ? label(labels, "Pause") : label(labels, "Play"),
    icon: playing ? PauseIcon : PlayIcon,
    renderIcon: playing ? render.iconSlideshowPause : render.iconSlideshowPlay,
    onClick: togglePlaying,
    disabled: disabled,
    "aria-disabled": disabled
  });
};